import { Routes } from '@angular/router';
import { authGuard } from './core/session/auth.guard';
import { TermosListComponent } from './features/gestao-termos/termos-list.component';
import { NotFoundComponent } from './features/not-found/not-found.component';

export const routes: Routes = [
  { path: '', redirectTo: 'termos', pathMatch: 'full' },
  { path: 'termos', component: TermosListComponent, canActivate: [authGuard] },
  // Sem guarda: é para onde o próprio `authGuard` manda quem não tem sessão.
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found' },
];
